import React from "react";

type IconButtonPropsType = {
  buttonClasses?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
};

const IconButton = ({
  buttonClasses = "",
  onClick,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"button"> & IconButtonPropsType) => {
  return (
    <button
      className={`bg-transparent p-0 border-none text-gray-60 ${buttonClasses}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default IconButton;
